import { render, staticRenderFns } from "./LayoutNotfound.vue?vue&type=template&id=1257adeb&scoped=true&"
import script from "./LayoutNotfound.vue?vue&type=script&lang=js&"
export * from "./LayoutNotfound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1257adeb",
  null
  
)

export default component.exports